/**
 * Reads customer/site restriction notes from API payloads (camelCase or PascalCase).
 */
export function pickCustomerSiteRestrictions(...sources: unknown[]): string {
    for (const src of sources) {
        if (!src || typeof src !== "object") continue;
        const o = src as Record<string, unknown>;
        const v =
            o.customerSiteRestrictions ??
            o.customer_Site_Restrictions ??
            o.Customer_Site_Restrictions ??
            o.customer_site_restrictions;
        if (typeof v === "string") {
            const t = v.trim();
            if (t.length > 0) return v;
            continue;
        }
        if (v != null) return String(v);
    }
    return "";
}
